import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { apiSelfCareFetcher } from '@/api/fetcher';
import { components, operations } from '@/api/skippay/generated/selfCare';
import { URLS } from '@/constants/api';
import { QUERY_KEYS } from '@/constants/queryKeys';
type FeatureFlagsResponse = operations['featureFlags']['responses']['200']['content']['application/json'];
type PublicFeatureFlagsResponse = FeatureFlagsResponse & {
  bnplLimitsMinimal?: components['schemas']['FeatureStateEnum'];
};
export function useBnplLimitsMinimal() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: QUERY_KEYS.featureFlags(),
      queryFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useQuery(t0);
  return data?.bnplLimitsMinimal === "ENABLED";
}
async function _temp() {
  const response = await apiSelfCareFetcher(URLS.featureFlags);
  if (!response.json) {
    throw new Error("No data returned");
  }
  return response.json;
}